import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";

export default function VerifyEmail() {
  const { verifyEmail, refresh } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    verifyEmail(token).then(() => { setStatus("ok"); refresh(); }).catch(() => setStatus("error"));
  }, [token, verifyEmail, refresh]);

  return (
    <AuthShell title="E-MAIL BEVESTIGEN" subtitle="">
      <div className="text-center" data-testid="verify-result">
        {status === "loading" && <Loader2 className="mx-auto h-12 w-12 animate-spin text-[#FF6A00]" />}
        {status === "ok" && <><CheckCircle2 className="mx-auto mb-3 h-12 w-12 text-[#22C55E]" /><p className="text-[#cfcfcf]">Je e-mailadres is bevestigd!</p><Link to="/" className="mt-4 inline-block font-semibold text-[#FF6A00] hover:underline">Naar de marktplaats</Link></>}
        {status === "error" && <><XCircle className="mx-auto mb-3 h-12 w-12 text-[#EF4444]" /><p className="text-[#cfcfcf]">Deze bevestigingslink is ongeldig of verlopen.</p><Link to="/" className="mt-4 inline-block font-semibold text-[#FF6A00] hover:underline">Naar home</Link></>}
      </div>
    </AuthShell>
  );
}
